import React, { Component, CSSProperties, FC, useCallback, useMemo } from 'react';
import classNames from 'classnames';
import { ChangeAction } from 'redux-form';
import { useTranslationAPI } from '../../../../../../ReactSharedScripts/modules/translations';
import { TooltipBtn } from '../../../../../../ReactSharedScripts/components/TooltipBtn';
import { Filter } from '../../../../../../ReactSharedScripts/components/Icons/Filter';
import { ThemeStyle } from '../../../../../../ReactSharedScripts/utils/const';
import classes from './styles/index.module.scss';

type SpreadsheetHeadFilterProps = {
	translate?: (number) => string;
	isPending?: boolean;
	change?: ChangeAction;
	submit?: (formName: string) => void;
	filterFormName?: string;
};

type SpreadsheetHeadRowItemProps = {
	width?: string;
	styles?: CSSProperties;
	filters?: typeof Component;
	className?: string;
	isFilterable?: boolean;
	hasFilterChanged?: boolean;
};

export const SpreadsheetHeadRowItem: FC<
	React.PropsWithChildren<SpreadsheetHeadRowItemProps & SpreadsheetHeadFilterProps>
> = ({
	filters: Filters,
	filterFormName,
	change,
	submit,
	isFilterable,
	className,
	children,
	width,
	styles,
	isPending,
	hasFilterChanged,
}) => {
	const { translate } = useTranslationAPI();
	const componentClasses = classNames(classes.headRowItem, className);

	const style = useMemo(() => {
		return {
			width,
			...styles,
		};
	}, [styles, width]);

	const filterTooltipButtonClasses = classNames(classes.filterTooltipButton, {
		[classes.filterTooltipButton_active]: hasFilterChanged,
	});

	const handleFilterTooltipClose = useCallback(() => {
		if (typeof submit !== 'undefined' && typeof filterFormName !== 'undefined') {
			submit(filterFormName);
		}
	}, [filterFormName, submit]);

	return (
		<div
			className={componentClasses}
			style={style}
		>
			{isFilterable && typeof Filters !== 'undefined' && (
				<TooltipBtn
					tooltip={
						<div className={classes.filterTooltip}>
							<Filters
								translate={translate}
								isPending={isPending}
								isDarkTheme={false}
								change={change}
								submit={submit}
								filterFormName={filterFormName}
							/>
						</div>
					}
					tooltipTheme={ThemeStyle.Light}
					tooltipPosition='bottom'
					tooltipAlign='start'
					hasTooltipIcon={false}
					size='tiny'
					icon={<Filter />}
					groupName='dateFilter'
					className={filterTooltipButtonClasses}
					onClose={handleFilterTooltipClose}
				>
					<Filter />
				</TooltipBtn>
			)}
			{children}
		</div>
	);
};
